import { createContext, useState, useCallback, useContext } from 'react';
import { jsx } from 'react/jsx-runtime';

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

/**
 * @deprecated Consult with frontend chapter for better alternatives
 */
var PermissionContext = /*#__PURE__*/createContext({});

/**
 * @deprecated Consult with frontend chapter for better alternatives
 */

/**
 * @deprecated Consult with frontend chapter for better alternatives
 */
function ApplicationContext(_ref) {
  var _this = this;
  var children = _ref.children;
  var _useState = useState([]),
    permissions = _useState[0],
    setPermissions = _useState[1];
  var _useState2 = useState(''),
    assetUrl = _useState2[0],
    setAssetUrl = _useState2[1];
  var _useState3 = useState(''),
    logoPath = _useState3[0],
    setLogoPath = _useState3[1];
  var addPermission = useCallback(function (permission) {
    if (Array.isArray(permission)) {
      setPermissions(function (oldPermissions) {
        return [].concat(oldPermissions, permission);
      });
      return;
    }
    setPermissions(function (oldPermissions) {
      return [].concat(oldPermissions, [permission]);
    });
  }, []);
  var removePermission = useCallback(function (permission) {
    if (permissions.includes(permission)) {
      setPermissions(function (oldPermissions) {
        return oldPermissions.filter(function (p) {
          return p !== permission;
        });
      });
    }
  }, [permissions]);
  var hasPermissions = useCallback(function (requiredPermissions) {
    if (Array.isArray(requiredPermissions)) {
      return requiredPermissions.every(function (permission) {
        return permissions.includes(permission);
      });
    }
    return permissions.includes(requiredPermissions);
  }, [permissions]);
  var withPermissions = useCallback(function (requiredPermissions, component, elseComponent) {
    if (hasPermissions(requiredPermissions)) {
      // @ts-ignore
      return component.apply(_this);
    }

    // @ts-ignore
    return elseComponent ? elseComponent.apply(_this) : null;
  }, [hasPermissions]);
  return /*#__PURE__*/jsx(PermissionContext.Provider, {
    value: {
      hasPermissions: hasPermissions,
      addPermission: addPermission,
      withPermissions: withPermissions,
      removePermission: removePermission,
      permissionsInitialized: permissions.length > 0,
      setAssetUrl: setAssetUrl,
      assetUrl: assetUrl,
      setLogoPath: setLogoPath,
      logoPath: logoPath
    },
    children: children
  });
}

/**
 * @deprecated Consult with frontend chapter for better alternatives
 */
function withApplicationContext(Component) {
  var displayName = "withApplicationContext(" + (Component.displayName || Component.name || 'Unknown') + ")";
  var C = function C(props) {
    return /*#__PURE__*/jsx(PermissionContext.Consumer, {
      children: function children(ctx) {
        return /*#__PURE__*/jsx(Component, _extends({}, props, {
          ctx: ctx,
          permissions: ctx.withPermissions
        }));
      }
    });
  };
  C.displayName = displayName;
  C.WrappedComponent = Component;
  return C;
}

/**
 * @deprecated Consult with frontend chapter for better alternatives
 */
function useApplicationContext() {
  return useContext(PermissionContext);
}

export { ApplicationContext, PermissionContext, useApplicationContext, withApplicationContext };
//# sourceMappingURL=index.js.map
